import ThrobberLoading from './ThrobberLoading';

const LoadingUI = ({ message = "Loading...", type }) => {
  return (
    <div className='containLoading'>
      {type === "Throbber" && <ThrobberLoading />}

      {type === "Text Only" && message.length > 2 ? (
        <div className='text-only'>
          <p style={{ textAlign: 'center', color: '#fff', margin: 'auto' }}>{message}</p>
        </div>
      ) : (
        type !== "Default" && message.length > 2 && (
          <div className='text-only'>
            <p style={{ textAlign: 'center', color: '#fff', margin: 'auto' }}>{message}</p>
          </div>
        )
      )}
    </div>
  );
};

export default LoadingUI;
